import {
  ActivitiesPageFilters,
  DurationFilter,
} from "domain/entities/activities.entities";

export const getFiltersCount = (
  filters: ActivitiesPageFilters & {
    [key: string]: string[] | string | boolean | number | DurationFilter;
  },
  minDuration?: number,
  maxDuration?: number,
  favorite?: boolean
) => {
  let count = 0;
  if (filters.contexts?.length > 0) count++;
  if (filters.types?.length > 0) count++;
  if (filters.techObjectives?.length > 0) count++;
  if (filters.seanceObjectives?.length > 0) count++;
  if (filters.participants) count++;
  if (filters.modalities?.length > 0) count++;
  if (filters.categories?.length > 0) count++;
  if (filters.selectedDuration?.length > 0) count++;
  if (
    filters.duration &&
    typeof minDuration !== "undefined" &&
    typeof maxDuration !== "undefined" &&
    (filters.duration.$gte !== minDuration ||
      filters.duration.$lte !== maxDuration)
  ) {
    count++;
  }
  if (favorite) count++;
  if (filters.level?.length > 0) count++;
  return count;
};
